import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import ImageGallery from './components/ImageGallery';
import 'antd/dist/reset.css';
import './App.css';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        <header className="app-header">
          <h1>图片画廊</h1>
        </header>
        <ImageGallery />
      </div>
    </ConfigProvider>
  );
}

export default App;
